import React from 'react';
import { bool, node, object, string } from 'prop-types';

import { Arrow, TooltipContent, TooltipContentWrapper } from './styles';

/**
 * Toltip Component
 * this tooltip props come from OverlayTrigger
 * @typedef {{
 * popper: { ref: React.RefObject, styles: React.CSSProperties, placement: import('../OverlayTrigger').PlacementProps },
 * arrow: { ref: React.RefObject, styles: React.CSSProperties },
 * id: string,
 * show: boolean,
 * arrowProps: Object }} TooltipProps
 * @type {React.FC<TooltipProps>}
 * @returns
 */
const Tooltip = (props) => {
  const { popper, arrow, id, arrowProps, show, children, ...rest } = props;

  return (
    <TooltipContentWrapper
      ref={popper.ref}
      style={popper.styles}
      id={id}
      data-placement={popper.placement}
    >
      <TooltipContent show={show} {...rest}>
        {children}
      </TooltipContent>
      <Arrow
        ref={arrow.ref}
        style={arrow.styles}
        data-placement={popper.placement}
        show={show}
        {...arrowProps}
      />
    </TooltipContentWrapper>
  );
};

Tooltip.propTypes = {
  id: string,
  arrow: object,
  arrowProps: object,
  popper: object,
  children: node,
  show: bool,
};

Tooltip.defaultProps = {
  show: false,
  children: null,
};

export default Tooltip;
